import { BaseballLineupPosition, constants } from '@trackman/baseball-shared-components';
import { ApiLineupDraggablePlayer } from 'interfaces/team/ApiLineupDraggablePlayer';
import { makeObservable, observable } from 'mobx';
import { emptyLineupPlayer } from '../../services/helper-services/constants';

export class Lineup {
  constructor(players: ApiLineupDraggablePlayer[]) {
    this.players = players;
    makeObservable(this);
  }

  @observable
  players: ApiLineupDraggablePlayer[];

  getPlayer = (position: BaseballLineupPosition) => {
    const player = this.players.find((player) => player.position === position.toString());
    if (!player) {
      return { ...emptyLineupPlayer, isEnabled: true, name: constants.emptyGuid };
    }

    return player;
  };

  getDefensivePlayer = (position: BaseballLineupPosition) => {
    const player = this.players.find((player) => player.position === position.toString());
    if (!player) {
      return null;
    }

    return player;
  };

  getBatterList = () => {
    if (this.players.some((p) => p.position === BaseballLineupPosition.DesignatedHitter)) {
      return this.players.filter((p) => p.position !== BaseballLineupPosition.Pitcher);
    }
    return this.players;
  };

  getNextBatter = (lastBatterId: string | undefined) => {
    const batters = this.getBatterList();
    let index = lastBatterId ? batters.findIndex((t) => t.id === lastBatterId) : -1;
    index++;
    if (index >= batters.length) {
      index = 0;
    }

    return batters[index];
  };

  isPlayerInLineup = (playerId: string) => {
    return this.players.some((p) => p.id === playerId);
  };
}
